import dayjs from 'dayjs'

const state = {
  themeName: '',
}

const chunjie = [
  // '2024/2/10', '2024/2/11', '2024/2/12',
  // '2025/1/29', '2025/1/30', '2025/1/31',
  '2026/2/17', '2026/2/18', '2026/2/19',
  '2027/1/6', '2027/1/7', '2027/1/8',
  '2028/1/26', '2028/1/27', '2028/1/28',
  '2029/2/13', '2029/2/14', '2029/2/15',
]
const yuanxiao = ['2024/2/24', '2025/2/12', '2026/3/03']
const duanwu = ['2024/6/10', '2025/5/31', '2026/6/19']
const qixi = ['2024/8/10', '2025/8/29', '2026/8/19']
const zhongyuan = ['2024/8/18', '2025/9/6', '2026/8/27', '2027/8/16', '2028/9/3', '2029/8/24', '2030/8/13', '2031/9/1']
const zhongqiu = ['2024/9/17', '2025/10/6', '2026/9/25',]
const chongyang = ['2024/10/11', '2025/10/29', '2026/10/18',]

const getters = {
  h5Banner: (state, getters, rootState) => {
    if (state.themeName) {
      return `/h5-static/theme/h5/${state.themeName}_logo.png`
    }
    // if (!rootState.userData.uid) {
    //   return '/h5-static/theme/h5/logo.png' // 未登錄
    // }
    // if (!rootState.userData.settings || rootState.userData.hasJyorder < 1) {
    //   return '/h5-static/theme/h5/logo-n.png' // 新用戶/未下單
    // }
    if (rootState.edition === 's') {
      if (rootState.userData.settings.privSrLabel === 'SHOPEE26') {
        return '/h5-static/theme/h5/logo-shopee.png' // 商務版
      }
      return '/h5-static/theme/h5/logo-s.png' // 商務版
    }
    // return '/h5-static/theme/h5/logo-g.png' // 個人版
    return '/h5-static/theme/h5/logo.png'
  },
  pcLogo1: (state, getters) => `https://static.kkren.com.tw/static/theme/pc/${state.themeName ? state.themeName + '_' : ''}logo_1.png`,
  pcLogo2: (state, getters) => `https://static.kkren.com.tw/static/theme/pc/${state.themeName ? state.themeName + '_' : ''}logo_2.png`,
  pcLogo3: (state, getters) => `https://static.kkren.com.tw/static/theme/pc/${state.themeName ? state.themeName + '_' : ''}logo_3.png`,
}

const mutations = {
  setThemeName (state, value) {
    state.themeName = value
  },
}

const actions = {
  index ({ rootState, commit }, params) {
    return rootState.axios.get('/jyb/v1frontend/poll/index', { params }).then(res => {
      commit('setPollData', res.data.list)
    })
  },
  initTheme ({ commit }) {
    const cur = dayjs()
    const ymd = cur.format('YYYY/M/D')
    const md = cur.format('M/D')
    let themeName = ''
    if (zhongyuan.includes(ymd)) {
      themeName = 'zhongyuan'
    } else if (zhongqiu.includes(ymd)) {
      themeName = 'zhongqiu'
    } else if (duanwu.includes(ymd)) {
      themeName = 'duanwu'
    } else if (chongyang.includes(ymd)) {
      themeName = 'chongyang'
    } else if (qixi.includes(ymd)) {
      themeName = 'qixi'
    } else if (yuanxiao.includes(ymd)) {
      themeName = 'yuanxiao'
    } else if (chunjie.includes(ymd)) {
      themeName = 'chunjie'
    } else if (md === '1/1' || md === '1/2' || md === '1/3') {
      themeName = 'newDay'
    } else if (md === '12/25') {
      themeName = 'christmas'
    }
    // themeName = 'chunjie'
    commit('setThemeName', themeName)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
